"use strict";

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IPCChannel = void 0;

var path = require("path");

var axon = require("pm2-axon");

var os_1 = require("os");

var pm2_axon_rpc_1 = require("pm2-axon-rpc");

var events_1 = require("events");

var utils_1 = require("./utils");

var CONNECTION_TIME_OUT = 2000;

var getSocketsPath = function getSocketsPath(dataPath) {
  var socketDir = path.join(path.resolve(dataPath.replace('~', os_1.homedir())), 'tmp', 'sockets');
  return {
    root: "unix://".concat(socketDir),
    pub: "unix://".concat(socketDir, "/pub_socket.sock"),
    sub: "unix://".concat(socketDir, "/sub_socket.sock"),
    rpc: "unix://".concat(socketDir, "/bus_rpc_socket.sock")
  };
};

var IPCChannel = /*#__PURE__*/function () {
  function IPCChannel(dataPath) {
    _classCallCheck(this, IPCChannel);

    var socketsDir = getSocketsPath(dataPath);
    this._eventPubSocketPath = socketsDir.pub;
    this._eventSubSocketPath = socketsDir.sub;
    this._rpcServerSocketPath = socketsDir.rpc;
    this._pubSocket = axon.socket('push', {});
    this._subSocket = axon.socket('sub', {});
    this._rpcClient = new pm2_axon_rpc_1.Client(axon.socket('req'));
    this._events = new events_1.EventEmitter();
    this._id = 0;
  }

  _createClass(IPCChannel, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new Promise(function (resolve, reject) {
                  var timeout = setTimeout(function () {
                    reject(new Error('IPC Socket client connection timeout. Please check if IPC server is running.'));
                  }, CONNECTION_TIME_OUT);

                  _this._pubSocket.on('connect', function () {
                    clearTimeout(timeout);
                    resolve(undefined);
                  });

                  _this._pubSocket.on('error', reject);

                  _this._pubSocket.connect(_this._eventSubSocketPath);
                }).finally(function () {
                  _this._pubSocket.removeAllListeners('connect');

                  _this._pubSocket.removeAllListeners('error');
                });

              case 2:
                _context.next = 4;
                return new Promise(function (resolve, reject) {
                  var timeout = setTimeout(function () {
                    reject(new Error('IPC Socket client connection timeout. Please check if IPC server is running.'));
                  }, CONNECTION_TIME_OUT);

                  _this._subSocket.on('connect', function () {
                    clearTimeout(timeout);
                    resolve();
                  });

                  _this._subSocket.on('error', reject);

                  _this._subSocket.connect(_this._eventPubSocketPath);
                }).finally(function () {
                  _this._subSocket.removeAllListeners('connect');

                  _this._subSocket.removeAllListeners('error');
                });

              case 4:
                _context.next = 6;
                return new Promise(function (resolve, reject) {
                  var timeout = setTimeout(function () {
                    reject(new Error('IPC Socket client connection timeout. Please check if IPC server is running.'));
                  }, CONNECTION_TIME_OUT);

                  _this._rpcClient.sock.on('connect', function () {
                    clearTimeout(timeout);
                    resolve(undefined);
                  });

                  _this._rpcClient.sock.on('error', reject);

                  _this._rpcClient.sock.connect(_this._rpcServerSocketPath);
                }).finally(function () {
                  _this._rpcClient.sock.removeAllListeners('connect');

                  _this._rpcClient.sock.removeAllListeners('error');
                });

              case 6:
                this._subSocket.on('message', function (eventData) {
                  _this._events.emit(eventData.method, eventData.params);
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._subSocket.removeAllListeners();

                this._pubSocket.close();

                this._subSocket.close();

                this._rpcClient.sock.close();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "invoke",
    value: function () {
      var _invoke = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(actionName, params) {
        var _this2 = this;

        var action;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._id += 1;
                action = {
                  id: this._id,
                  jsonrpc: '2.0',
                  method: actionName,
                  params: params !== null && params !== void 0 ? params : {}
                };
                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  _this2._rpcClient.call('invoke', action, function (err, data) {
                    if (err) {
                      reject(utils_1.convertRPCError(err));
                      return;
                    }

                    if (data.error) {
                      reject(utils_1.convertRPCError(data.error));
                      return;
                    }

                    resolve(data.result);
                  });
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function invoke(_x, _x2) {
        return _invoke.apply(this, arguments);
      }

      return invoke;
    }()
  }, {
    key: "subscribe",
    value: function subscribe(eventName, cb) {
      this._events.on(eventName, cb);
    }
  }]);

  return IPCChannel;
}();

exports.IPCChannel = IPCChannel;